import type { OpeningOrderFeeGetResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useOpeningOrderFeeGetByBuyer = <
  TData = OpeningOrderFeeGetResponseType,
>(
  retailerId: number,
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [business?.id, ServerStateKeys.OpeningOrderFee, retailerId],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `opening-order-fee/by-retailer/${retailerId}`,
      }).then((response) => apiV2AssertResponse<TData>(response).data),
    ...getDefaultQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: options,
    }),
  });
};
